export default function Equipment() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Equipment Management</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">Inverters</h3>
          <p className="text-gray-600 mb-4">Monitor and manage solar inverters</p>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Active Inverters:</span>
              <span className="font-semibold">24</span>
            </div>
            <div className="flex justify-between">
              <span>Total Capacity:</span>
              <span className="font-semibold">2.4 MW</span>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">Panels</h3>
          <p className="text-gray-600 mb-4">Solar panel status and performance</p>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Total Panels:</span>
              <span className="font-semibold">1,200</span>
            </div>
            <div className="flex justify-between">
              <span>Operational:</span>
              <span className="font-semibold text-green-600">1,195</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}